import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const BackButtonMainDiv = styled.div`
  margin-left: var(--space-12);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  ${mobile_xl(css`
    padding-top: var(--space-4);
  `)};
`;

const MainDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  ${mobile_xl(css`
    gap: var(--space-24);
  `)}
`;

export { Content, MainDiv, BackButtonMainDiv };
